import React from 'react';

import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/AUTODashboard/Header/WelcomeHeader/messages';
import { MediumSectionHeader } from 'components/Typography';
import { capitalize } from 'utils/string';
import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Header/WelcomeHeader/styles';

interface WelcomeHeaderPropsType {
  name: string;
  intl: IntlShape;
}
const WelcomeHeader = (props: WelcomeHeaderPropsType) => {
  return (
    <>
      <MediumSectionHeader color="#FFFFFF">
        {translate({ ...messages.headerTitle }, props, {
          name: capitalize(props.name),
        })}
      </MediumSectionHeader>
      <StyledSmallSectionHeader weight="400" color="#FFFFFF">
        {translate({ ...messages.headerSubtitle }, props)}
      </StyledSmallSectionHeader>
    </>
  );
};

export default injectIntl(WelcomeHeader);
